// machineActions.js
export const INIT_MACHINE_LIST_REQUEST = 'INIT_MACHINE_LIST_REQUEST';
export const SET_MACHINE_LIST = 'SET_MACHINE_LIST'; // use to set machine list data
export const ERROR_MACHINE_LIST = 'ERROR_MACHINE_LIST'; // use for all types of errors
export const ERROR_MACHINE = 'ERROR_MACHINE'; // use for all types of error (edit, update and view)
export const SET_MACHINE = 'SET_MACHINE'; // use for single machine
export const ADD_MACHINE = 'ADD_MACHINE'; // use to add new machine
export const UPDATE_MACHINE = 'UPDATE_MACHINE'; // use to update machine
export const DELETE_MACHINE = "DELETE_MACHINE"
export const  SET_MACHINE_LIST_BY_COMPANY_ID='SET_MACHINE_LIST_BY_COMPANY_ID';
export function initMachineListRequest() {
  return { type: INIT_MACHINE_LIST_REQUEST };
}

export function setMachineList(data) {
  return { type: SET_MACHINE_LIST, payload: data };
}

export function setMachineListByCompanyId(data){
   return {type:SET_MACHINE_LIST_BY_COMPANY_ID,payload:data}; //added new 
}
export function errorMachineList(error) {
  return { type: ERROR_MACHINE_LIST, payload: error };
}

export function errorMachine(data) {
  return { type: ERROR_MACHINE, payload: data };
}

export function addMachine(machine) {
  return { type: ADD_MACHINE, payload: machine };
}

export function updateMachine(machine) {
  return { type: UPDATE_MACHINE, payload: machine };
}

export function setMachine(data) {
  return { type: SET_MACHINE, payload: data };
}

export function deleteMachine(data) {
  return { type: DELETE_MACHINE, payload: data };
}